import TestInstructionItem from './TestInstrcutionItem'
import Button from 'components/UI/Button'
import { useNavigate } from 'react-router-dom'

import ErrorMessageWithExclamation from 'components/UI/ErrorMessageWithExclamation'
import { useDispatch, useSelector } from 'react-redux'
import { selectInstructionError } from 'routing/fetchingfunction/user/user.reducer'
import { Icon } from 'components/UI'
import { clearInstructionError } from 'routing/fetchingfunction/user/user.action'
import { useEffect, useState } from 'react'

const TestInstructions = ({ onSubmit, onCancel }) => {
  const error = useSelector(selectInstructionError)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSubmit = () => {
    setLoading(true)
    console.log(onSubmit(), 'onSubmit result in TestInstructions.jsx')
    // onSubmit()
    // .catch((err) => {
    //   console.error('[Proctoring]', err)
    // })
    // .finally(() => {
    //   setLoading(false)
    // })
  }

  console.log(error)

  useEffect(() => {
    dispatch(clearInstructionError())
  }, [])

  // console.log('error in TestInstructions')
  // console.log(error, 'error in TestInstructions')
  const handleGoBack = (e) => {
    e.preventDefault()
    // Just navigate back one page in history without canceling the test
    if (onCancel) {
      onCancel()
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="max-w-[504px] w-full mx-auto flex flex-col items-center justify-start">
      <div className="mb-6">
        <h3 className="text-2xl text-primary-100 md:text-3xl font-semibold mb-2 md:mb-3 text-center pt-4">
          Test Rules & Scoring System{' '}
        </h3>
        <h5 className="text-center font-semibold">
          {' '}
          <Icon name="warning-triangle" color="#f79009" className="w-6 h-6 mr-[6px] inline-block" />
          Important Test Information{' '}
        </h5>

        <p className="text-center font-medium">
          At APOLO we do our best to find real experts. Please review these rules carefully before
          you begin.{' '}
        </p>
      </div>

      {error && (
        <div className="!mb-4 text-error-500">
          <p className="font-bold">Following errors occur</p>
          <ErrorMessageWithExclamation text={error} />
        </div>
      )}

      <div className="bg-primary-500 p-4 md:p-6 rounded-lg w-full mb-6 pb-2">
        <ul className="flex flex-col items-start justify-start">
          <TestInstructionItem>
            All selected tests must be completed one after another, in the order they were chosen.
            If you'd like to take only one test, please go back and select that test alone.
          </TestInstructionItem>
          <TestInstructionItem>
            Switching tabs or minimizing the window is allowed only once as a warning. Any further
            actions will result in the test being cancelled.
          </TestInstructionItem>
          <TestInstructionItem>
            If you cancel a test midway, it will be marked as a failed test. You can retake the test
            after 30 days, with a new set of questions.
          </TestInstructionItem>

          <TestInstructionItem>
            If you fail, you can also retake the test after 30 days with new questions.{' '}
          </TestInstructionItem>
          <TestInstructionItem>
            You will have 30 minutes to answer 60 questions.{' '}
          </TestInstructionItem>

          <TestInstructionItem>
            <div>
              <p>Scoring levels: </p>
              <ul className="list-disc list-inside">
                <li>Fewer than 35 correct answers: Fail</li>
                <li>35–44: Beginner level</li>
                <li>45–54: Intermediate level</li>
                <li>55–60: Expert level</li>
              </ul>
            </div>
          </TestInstructionItem>
        </ul>
      </div>

      <div className="flex flex-col item-center justify-start w-full font-semibold">
        <Button isLoading={loading} className="w-full !mb-3" onClick={handleSubmit}>
          I'm Ready
        </Button>

        <Button
          className="bg-white !text-primary-150 border !border-primary-75 p-[10px]"
          onClick={handleGoBack}
        >
          Go Back
        </Button>
      </div>
    </div>
  )
}
export default TestInstructions
